import angular from 'angular';
import subcontractorDetailsComponent from './subcontractor-details.component';

let subcontractorDetailsModule = angular.module('subcontractorDetails', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('subcontractorDetails', subcontractorDetailsComponent);

export default subcontractorDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontractor-details/subcontractor-details.js